import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { filter, sortBy } from "lodash";

// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";

// Utils
import genericAction from "@Redux/Actions/generic";
import dataHandler from "@Utils/dataHandler";
import { dropdownFormat } from "@Utils/formats";

// Modals
import MenuCrud from "./Modals/MenuCrud";

// Styles
import styles from "./styles.module.css";

const UserPermissions = ({ dispatch, userName, companyName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openMenuCrud, setOpenMenuCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [filteredCount, setFilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [parentsMenus, setParentsMenus] = useState([]);
	const [selectedParentId, setSelectedParentId] = useState(null);
	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const menuPromise = dataHandler({
				dispatch,
				url: "menu",
				params: defaultParams,
			});
			const parentsPromise = dispatch(genericAction({ method: "get", route: "menu/all" }));
			const [menuResponse, parentsResponse] = await Promise.all([menuPromise, parentsPromise]);
			setFilteredCount(menuResponse.count);
			setFilteredItems(menuResponse.items);
			const menuItem = filter(parentsResponse, (item) => {
				return item.type === "menu" && item.parentId === null;
			});
			const sortedMenu = sortBy(menuItem, [
				(menu) => {
					return (menu.name || "").toLowerCase();
				},
			]);
			setParentsMenus(dropdownFormat(sortedMenu, "name", "id"));
		})();
	}, []);

	// modal handler
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenMenuCrud(true);
	};

	// table Handler

	const handleButton = async (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	// data handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "menu", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}
	};

	const refresh = async () => {
		const menuPromise = dataHandler({
			dispatch,
			url: "menu",
			params: defaultParams,
		});
		const parentsPromise = dispatch(genericAction({ method: "get", route: "menu/all" }));
		const [menuResponse, parentsResponse] = await Promise.all([menuPromise, parentsPromise]);
		setFilteredCount(menuResponse.count);
		setFilteredItems(menuResponse.items);
		const menuItem = filter(parentsResponse, (item) => {
			return item.type === "menu" && item.parentId === null;
		});
		const sortedMenu = sortBy(menuItem, [
			(menu) => {
				return (menu.name || "").toLowerCase();
			},
		]);
		setParentsMenus(dropdownFormat(sortedMenu, "name", "id"));
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Menú">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",
									action: [{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" }],
									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Nombre",
									key: "name",
									format: "string",
									width: 1,
								},

								{
									label: "Orden",
									key: "order",
									format: "string",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Tipo",
									key: "type",
									format: "string",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Padre",
									key: "parent.name",
									format: "string",
								},
								{
									label: "Path",
									key: "path",
									format: "string",
									width: 1,
								},
								{
									label: "Icono",
									key: "icon",
									format: "string",
									headerPosition: "left",
									width: 5,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButton}
							addButton={{ label: "Agregar" }}
							searcher={{ width: "40rem" }}
							print={{ printHeader: { company: companyName, title: "Menú", user: userName } }}
						/>
					</div>
				</div>
			</div>
			{openMenuCrud && (
				<MenuCrud
					parentsMenus={parentsMenus}
					tableValue={tableValue}
					refresh={refresh}
					onClose={() => {
						setOpenMenuCrud(false);
					}}
					modalCrud={modalOption}
					selectedParentId={selectedParentId}
					setSelectedParentId={setSelectedParentId}
				/>
			)}
		</Screen>
	);
};
function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.fullName,
		companyName: company.name,
	};
}

UserPermissions.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
};
export default connect(mapStateToProps)(UserPermissions);
